import { MDBBtn, MDBChip, MDBIcon, MDBInputGroup, MDBModalFooter, MDBSelect, MDBSpinner, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
import React, { forwardRef, useEffect, useRef, useState } from 'react'
import { customSearch, useAutoFocusSearchAfterLoads } from '../../../components/CustomSearchUtil/CustomSearch';
import { useTranslation } from 'react-i18next';

const AddUsersToFaxGroup = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const [selectedRows, setSelectedRows] = useState([]);
    const [addUsers, setAddUsers] = useState([]);
    const [removeUsers, setRemoveUsers] = useState([]);
    const [updatesourcedel, setUpdateSourceDel] = useState(false);
    const [selecteddUsers, setSelecteddUsers] = useState([]);
    const [prevaddedUsers, setPrevAddedUsers] = useState([]);
    const [sourceUsers, setSourceUsers] = useState([]);
    const [removeddUsers, setRemoveddUsers] = useState([]);
    const [searchSourceQuery, setSearchSourceQuery] = useState('');
    const [searchDetinationQuery, setSearchDetinationQuery] = useState('');
    const [addUsersExtensions, setAddUsersExtensions] = useState(new Set());
    const [sourceRecords, setSourceRecords] = useState([]);
    const [isSendList, setIsSendList] = useState([]);
    const [isRecieveList, setIsRecieveList] = useState([]);
    const [isSndRcvList, setIsSndRcvList] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    useAutoFocusSearchAfterLoads(dataLoaded, setDataLoaded, searchRef, true)
    //const [isloading, setIsloading] = useState(true);

    let proccessdRows = [];
    sourceUsers.map((member) => {
        proccessdRows.push({
            memberInfo: member,
            name: member.name ?? "",
            extension: member.extension ?? "",
            location_name: member?.location_name ?? "",
        });
    });



    const basicData = {
        columns: [
            { label: "Name", field: "name", sort: true },
            { label: "Extension", field: "extension" },
            { label: "Location", field: "location_name" },
            { label: "Add Send", field: "" },
            { label: "Add Receive", field: "" },
            { label: "Add Send & Receive", field: "" },
        ],
        rows: proccessdRows,
    };





    const addUser = (selectedObj) => {
        const itemIdex = addUsers.findIndex((item) => item.extension === selectedObj.extension);
        if (itemIdex === -1) {
            if (isSendList.includes(selectedObj.extension)) {
                selectedObj = { ...selectedObj, privilege: 1 };
            }
            else if (isRecieveList.includes(selectedObj.extension)) {
                selectedObj = { ...selectedObj, privilege: 2 };
            } else {
                selectedObj = { ...selectedObj, privilege: 3 };
                isSndRcvList.push(selectedObj.extension);
            }
            const updatedUsers = [...addUsers, selectedObj];
            setAddUsers(updatedUsers);
            const addUsersextension = new Set(updatedUsers.map(item => item.extension));
            setAddUsersExtensions(addUsersextension);
        } else {
            const updateList = [...addUsers];
            updateList.splice(itemIdex, 1);
            setAddUsers(updateList);
            const addUsersextension = new Set(updateList.map(item => item.extension));
            setAddUsersExtensions(addUsersextension);
            const extensionSelect = selectedObj.extension;
            isSendList.splice(isSendList.indexOf(extensionSelect), 1);
            isRecieveList.splice(isRecieveList.indexOf(extensionSelect), 1);
            isSndRcvList.splice(isSndRcvList.indexOf(extensionSelect), 1);
        }

        const newRemoveList = removeUsers.filter(item => item.extension !== selectedObj.extension);
        setRemoveUsers(newRemoveList);

    }

    const handleDelete = (removeObj) => {
        const updateAddList = addUsers.filter((item) => item.extension !== removeObj.extension);
        setAddUsers(updateAddList);
        const addUsersextension = new Set(updateAddList.map(item => item.extension));
        setAddUsersExtensions(addUsersextension);
        // const extensionSelect = selectedObj.extension;
        isSendList.splice(isSendList.indexOf(removeObj.extension), 1);
        isRecieveList.splice(isRecieveList.indexOf(removeObj.extension), 1);
        isSndRcvList.splice(isSndRcvList.indexOf(removeObj.extension), 1);
    }
    const filteredUsers = customSearch(sourceUsers, searchSourceQuery, [ "name", "extension" ]);

    function setSelectAll(e) {
        e.preventDefault();
        e.stopPropagation();



        // if no results, do nothing
        if (filteredUsers.length === 0) {
            return;
        }
        const addUserextension = new Set(addUsers.map(item => item.extension));
        const newAddUsers = filteredUsers.filter(item => !addUserextension.has(item.extension));
        let finalAddUsers = addUsers.concat(newAddUsers);
        finalAddUsers = finalAddUsers.map((user) => {
            if (isSendList.includes(user.extension)) {
                return { ...user, privilege: 1 };
            } else if (isRecieveList.includes(user.extension)) {
                return { ...user, privilege: 2 };
            } else if (isSndRcvList.includes(user.extension)) {
                return { ...user, privilege: 3 };
            } else {
                isSndRcvList.push(user.extension);
                return { ...user, privilege: 3 };
            }
        });
        setAddUsers(finalAddUsers);
        const finaladdUserextensions = new Set(finalAddUsers.map(item => item.extension));
        setAddUsersExtensions(finaladdUserextensions);
    }

    useEffect(() => {
        if (props.sourceUsers && !updatesourcedel) {
            
            if (props.selectedUsers.length > 0) {
                setSelecteddUsers(props?.selectedUsers ?? []);
                const extensionsToFilter = new Set(props.selectedUsers.map(item => item.extension));
                const filteredSource = props.sourceUsers.filter(item => !extensionsToFilter.has(item.extension));
                setSourceUsers(filteredSource);
                setSourceRecords(filteredSource);
            } else {
                setSourceUsers(props.sourceUsers);
                setSourceRecords(props.sourceUsers);
            }

            setUpdateSourceDel(true);
            props.setIsloading(false);
            if(!dataLoaded){setDataLoaded(true)}
        }
        
    }, [props, updatesourcedel]);

    function submitAddUsers(e) {
        props.setUpdateUsers(addUsers);
        props.setIsAddedUsers(true);
        props.onClose();
    }

    const updateSelectedStateData = (selectedState) => {
        let filteredAgents = selectedState != 'Select-Country' ? sourceRecords.filter((row) => row.location?.toString() === selectedState.toString()) ?? [] : sourceRecords
        setSourceUsers(filteredAgents);
    }

    function handleCheckBox(e, extension, flag) {
        if (e.target.checked) {
            if (flag === 1) {
                isSendList.push(extension);
                if (isRecieveList.indexOf(extension) !== -1) {
                    isRecieveList.splice(isRecieveList.indexOf(extension), 1);
                }
                if (isSndRcvList.indexOf(extension) !== -1) {
                    isSndRcvList.splice(isSndRcvList.indexOf(extension), 1);
                }
            } else if (flag === 2) {
                isRecieveList.push(extension);
                if (isSendList.indexOf(extension) !== -1) {
                    isSendList.splice(isSendList.indexOf(extension), 1);
                }
                if (isSndRcvList.indexOf(extension) !== -1) {
                    isSndRcvList.splice(isSndRcvList.indexOf(extension), 1);
                }
            } else {
                isSndRcvList.push(extension);
                if (isSendList.indexOf(extension) !== -1) {
                    isSendList.splice(isSendList.indexOf(extension), 1);
                }
                if (isRecieveList.indexOf(extension) !== -1) {
                    isRecieveList.splice(isRecieveList.indexOf(extension), 1);
                }
            }
            // isAdminList.push(extension);
            const updateUSers = addUsers.map((user) => user.extension == extension ? { ...user, privilege: flag } : user);
            setAddUsers(updateUSers);
        } else {
            if (isSendList.indexOf(extension) !== -1) {
                isSendList.splice(isSendList.indexOf(extension), 1);
            }
            if (isRecieveList.indexOf(extension) !== -1) {
                isRecieveList.splice(isRecieveList.indexOf(extension), 1);
            }
            if (isSndRcvList.indexOf(extension) !== -1) {
                isSndRcvList.splice(isSndRcvList.indexOf(extension), 1);
            }
            // const updatedUsers = addUsers.map(user => {
            //     if (user.extension == extension) {
            //         delete user.sndrcv;
            //     }
            //     return user;
            // });
            const updatedUsers = addUsers.map((user) => (user.extension == extension) ? { ...user, privilege: 3 } : user);
            const itemIdex = addUsers.findIndex((item) => item.extension === extension);
            if (itemIdex !== -1) {
                isSndRcvList.push(extension);
            }
            setAddUsers(updatedUsers);
        }
    }
    return (
        <>
            <div>
                {/* <div className="addAdminRole_Popup">

                    <MDBSelect className="w-100"
                        data={[
                            { text: "Select-Country", value: '-1' },
                            { text: "India", value: 'India' },
                            { text: "PAk", value: 'PAk' },
                            { text: "USA", value: 'USA' },
                            { text: "Four", value: 4 },
                            { text: "Five", value: 5 },
                            { text: "Six", value: 6 },
                            { text: "Seven", value: 7 },
                            { text: "Eight", value: 8 },
                        ]}
                        onSelect={(e) => updateSelectedStateData(e.target.value)}
                    />

                </div> */}
                <div className="pt-3">
                    {(selecteddUsers?.length>0 || addUsers?.length>0) && (
                    <MDBInputGroup className='mb-3' textAfter={<MDBIcon fas icon='search' />}>
                        <input className='form-control' type='text' placeholder='Search'
                            value={searchDetinationQuery}
                            onChange={(e) => setSearchDetinationQuery(e.target.value)}
                        />
                    </MDBInputGroup>)}
                    <div className="form-group row">
                        <div className="col-12">
                            <div className="form-outlines phoneNumberheight p-0">
                                <div className="chips chips-placeholder">
                                {selecteddUsers && selecteddUsers.length > 0 || addUsers && addUsers.length > 0 ? <>
                                    {selecteddUsers && selecteddUsers.length > 0 && (
                                           customSearch(selecteddUsers, searchDetinationQuery, [ "name", "extension" ])
                                            .map((item) => (
                                                <MDBChip
                                                    key={item.extension} className="m-chip d-inline py-2 px-3">
                                                    {item.name}
                                                </MDBChip>
                                            ))
                                    )}
                                    {addUsers && addUsers.length > 0 && (
                                        addUsers

                                            .map((item) => (
                                                <MDBChip
                                                    onDelete={() => handleDelete(item)} className="m-chip d-inline py-2 px-3"
                                                    key={item.extension} closeIcon size="sm">
                                                    {item.name} {item.privilege === 1 ? "(Send)" : item.privilege === 2 ? "(Recieve)" : item.privilege === 3 ? "(Send & Recieve)" : ""}
                                                </MDBChip>
                                            ))
                                    )}
                                      </> : <>
                                        <p className='m-1 text-secondary'>
                                            The selected Users will appear in this section
                                        </p>
                                    </>}
                                </div>
                            </div>
                            <label className="my-3 text-primary cursor-pointer " onClick={(e) => setSelectAll(e)}>
                                {t("selectAll")}
                            </label>
                            <MDBInputGroup className='mb-3' textAfter={<MDBIcon fas icon='search' />}>
                                <input className='form-control' type='text' ref={searchRef} placeholder='Search'
                                    value={searchSourceQuery}
                                    onChange={(e) => setSearchSourceQuery(e.target.value)} />
                            </MDBInputGroup>
                            <div className="addAdminTable_height">
                                <MDBTable className="mt-3"
                                    hover
                                    itemScope
                                    small
                                >
                                    <MDBTableHead className="table-header-sticky">
                                        <tr>
                                            <th>Name</th>
                                            <th>Extension</th>
                                            {/* <th>Location</th> */}
                                            <th>Add Send</th>
                                            <th>Add Receive</th>
                                            <th>Add Send & Receive</th>
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                        {filteredUsers?.length > 0 &&
                                          customSearch(filteredUsers, searchSourceQuery, [ "name", "extension" ])
                                            .map((row) => (
                                                <tr
                                                    key={row.extension}
                                                    className={addUsersExtensions?.has(row.extension) ? 'addUsers-select' : ''}
                                                    onClick={() => addUser(row)}
                                                >
                                                    <td>{row.name}</td>
                                                    <td>{row.extension}</td>
                                                    {/* <td>{row.location_name ?? ""}</td> */}
                                                    <td>
                                                        <>
                                                            <label className="switch" onClick={(e) => e.stopPropagation()}>
                                                                <input
                                                                    className="form-control"
                                                                    type="checkbox"
                                                                    checked={isSendList.includes(row.extension)}
                                                                    id="AllowUsersCallerID"
                                                                    name="manage_cid"
                                                                    onChange={(e) => {
                                                                        handleCheckBox(e, row.extension, 1)
                                                                    }
                                                                    }
                                                                />
                                                                <span className="slider round"></span>
                                                            </label>
                                                        </>
                                                    </td>
                                                    <td>
                                                        <>
                                                            <label className="switch" onClick={(e) => e.stopPropagation()}>
                                                                <input
                                                                    className="form-control"
                                                                    type="checkbox"
                                                                    checked={isRecieveList.includes(row.extension)}
                                                                    id="AllowUsersCallerID"
                                                                    name="manage_cid"
                                                                    onChange={(e) => {
                                                                        handleCheckBox(e, row.extension, 2)
                                                                    }
                                                                    }
                                                                />
                                                                <span className="slider round"></span>
                                                            </label>
                                                        </>
                                                    </td>
                                                    <td>
                                                        <>
                                                            <label className="switch" onClick={(e) => e.stopPropagation()}>
                                                                <input
                                                                    className="form-control"
                                                                    type="checkbox"
                                                                    checked={isSndRcvList.includes(row.extension)}
                                                                    id="AllowUsersCallerID"
                                                                    name="manage_cid"
                                                                    onChange={(e) => {
                                                                        handleCheckBox(e, row.extension, 3)
                                                                    }
                                                                    }
                                                                />
                                                                <span className="slider round"></span>
                                                            </label>
                                                        </>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                        {filteredUsers == undefined || filteredUsers?.length == 0 &&
                                            <td colSpan={4} className="text-center">
                                                No records found
                                            </td>
                                        }
                                    </MDBTableBody>
                                </MDBTable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => submitAddUsers(e)}>
                    {t("save")}</button>
            </div>

            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                    {t("close")}
                </MDBBtn>
                <MDBBtn onClick={(e) => submitAddUsers(e)}>{t("save")}</MDBBtn>
            </MDBModalFooter> */}
            {/* {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )} */}

        </>
    )
});

export default AddUsersToFaxGroup
